import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../../index';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const Cart = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description = t('ds.icon.cart.description'),
    dmId = 'dm-cart',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.cart.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="M10.1206428,17.0629454 C11.1937188,17.0629454 12.0636187,17.9442851 12.0636187,19.0314727 C12.0636187,20.1186603 11.1937188,21 10.1206428,21 C9.04756688,21 8.17766694,20.1186603 8.17766694,19.0314727 C8.17766694,17.9442851 9.04756688,17.0629454 10.1206428,17.0629454 Z M16.9260404,17.0629454 C17.9991164,17.0629454 18.8690163,17.9442851 18.8690163,19.0314727 C18.8690163,20.1186603 17.9991164,21 16.9260404,21 C15.8529645,21 14.9830646,20.1186603 14.9830646,19.0314727 C14.9830646,17.9442851 15.8529645,17.0629454 16.9260404,17.0629454 Z M4.68250234,4.00019906 C4.81805312,4.00305343 6.04925033,4.04542755 6.45389858,4.64608076 C6.88234968,5.28206651 6.80263785,5.58491686 7.12148517,6.07957245 C7.29885482,6.35289764 7.59594594,6.52220905 7.91860349,6.53384798 L7.91860349,6.53384798 L21.1507675,6.53384798 C21.4308548,6.53384798 21.670625,6.62101216 21.8337144,6.83112471 C21.9968038,7.04123727 22.0435467,7.32082751 21.9578498,7.5736342 L21.9578498,7.5736342 L20.1344417,13.5296912 C19.8182354,14.4890106 18.9672885,15.1644178 17.9722582,15.2458432 L17.9722582,15.2458432 L9.22388473,15.2458432 C8.27336536,15.155352 7.4514576,14.5366515 7.09159324,13.6407363 C7.08162926,13.6003563 7.0118814,13.4691211 7.0118814,13.378266 C6.72292602,12.3990499 5.41764477,7.02850356 5.12868939,6.53384798 C4.96316485,6.23794413 4.64690714,6.06210569 4.31164311,6.07957245 L4.31164311,6.07957245 L3.02628983,6.07957245 C2.45948561,6.07957245 2,5.6140443 2,5.03978622 C2,4.46552815 2.45948561,4 3.02628983,4 L3.02628983,4 Z"
      />
    </IconSvg>
  );
};

export default memo(Cart);
